<template>
    <div class="contact_us">


        <div class="us_content container-1200">
            <div class="content_left">
                <div class="left_form_content">
                    <FormBoxVue :title="'Name'" :isRequired="true">
                        <template #content>
                            <el-input v-model="formData.userName" placeholder=""></el-input>
                        </template>
                    </FormBoxVue>

                    <FormBoxVue :title="'Email'" :isRequired="true">
                        <template #content>
                            <el-input v-model="formData.userEmail" placeholder=""></el-input>
                        </template>
                    </FormBoxVue>

                    <FormBoxVue :title="'Country/Region'">
                        <template #content>
                            <el-select v-model="formData.country" filterable placeholder="" style="width: 100%;">
                                <el-option v-for="(item, index) in countriesList" :key="index" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </template>
                    </FormBoxVue>
                    <!-- 
                    <FormBoxVue :title="'Our Services'">
                        <template #content>
                            <el-tree ref="tree" :data='abstactData' show-checkbox node-key="id" :props="defaultProps"
                                :render-content="renderContent" default-expand-all>
                            </el-tree>
                        </template>
                    </FormBoxVue> -->

                    <!-- <FormBoxVue :title="'Our Services'">
                        <template #content>
                            <div>
                                <el-checkbox-group v-model="formData.services">
                                    <el-checkbox v-for="(item, index) in servicesList" :key="index"
                                        :label="item.label">{{ item.label }}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </template>
                    </FormBoxVue> -->

                    <FormBoxVue :title="'Phone number'">
                        <template #content>
                            <el-input v-model="formData.userPhone" placeholder=""></el-input>
                        </template>
                    </FormBoxVue>

                    <FormBoxVue :title="'Message'">
                        <template #content>
                            <el-input type="textarea" :rows="3" v-model="formData.remark" placeholder=""></el-input>
                        </template>
                    </FormBoxVue>
                </div>

                <div class="left_hint">
                    By submitting this form, I agree that Contrimetric may use my name, email address, phone number,
                    and country of
                    residence to provide support.
                    I agree that Contrimetric may process said data using third-party services for this purpose in
                    accordance with the
                    <span class="storng_text" @click="goToPolicy">Contrimetric Privacy policy</span>.
                </div>

                <div class="dialog_footer container-1200">
                    <el-button type="primary" @click="onDialogSubmit">Submit</el-button>
                </div>
            </div>

            <div class="content_right">
                <div class="right_content">If you need any help with Contrimetric plugin technical any special needs
                    or suggestions
                    for
                    Contrimetric tools,
                    please contact us by completing and submitting the request form or emailing us.
                </div>

                <div class="right_support">
                    <div class="address" style="font-weight: 800;">Address:</div>
                    <div>Singapore</div>
                    <div>
                        8 Eu Tong Sen Street,#16-81,The Central,Singapore 059818
                    </div>
                </div>

                <div class="right_support1">
                    <span style="color: black;">Phone: +1 949 972 8737</span><br>
                    <a href="mailto:contact@contrimetric.com?subject=&body=">contact@contrimetric.com</a>
                </div>
                <!-- <div class="right_support1">
                    Tech Support: <br>
                    <a href="mailto:contact@contrimetric.com?subject=&body=">contact@contrimetric.com</a>
                </div> -->
            </div>
        </div>


    </div>
</template>

<script>
import { MC, countriesList, onsultantObj, servicesList } from './data';
import { applyJournal, contactUs } from '@/api/widget/index';
import { isValidateEmail } from "@/utils/validate"
import FormBoxVue from "@/views/widget/components/formBox.vue"

export default {
    components: {
        FormBoxVue
    },
    data() {
        return {
            servicesList,
            MC,
            countriesList,
            onsultantObj,
            loading: false,
            defaultRegion: "Southeast Asia",
            formData: {
                userName: "",
                userEmail: "",
                country: "",
                userPhone: "",
                remark: "",
                services: []
            },
            width: "1200px",
            defaultProps: {
                children: 'children',
                label: 'label',
                inputValue: 'inputValue'
            }
        }
    },
    methods: {
        validateForm() {
            if (this.formData.userName == '' || this.formData.userEmail == '') {
                this.$message.warning("Please enter name and email")

                return false
            }
            return true
        },
        clearFormData() {
            for (let key in this.formData) {
                if (key === 'supportOrigin') {
                    this.formData[key] = this.defaultRegion;
                } else if (key === 'services') {
                    this.formData[key] = [];
                } else {
                    this.formData[key] = "";
                }
            }
        },
        async onDialogSubmit() {
            console.log(this.formData);

            if (this.validateForm()) {
                const validationResult = isValidateEmail(this.formData.userEmail)

                if (!validationResult) {
                    this.loading = true

                    await contactUs(this.formData).then(() => {
                        this.$message.success("Submit successfully")
                    }).catch((err) => {
                        this.$message.error(err || 'Unknown error')
                    }).finally(() => {
                        this.loading = false

                        this.clearFormData()
                    })
                } else {
                    this.$message.warning("Please enter the correct email address.")
                }
            }
        },
        goToPolicy() {
            window.open('https://contrimetric.com/privacy', '_blank')
        },
        updatePagerCount() {
            const width = window.innerWidth;
            this.width = width < 768 ? '100%' : '1200px';
        },
        renderContent(h, {
            node,
            data
        }) {
            let a = data.id.toString()[0]
            return h('span', data.label);
        },
    },
    mounted() {
        this.updatePagerCount();
        window.addEventListener('resize', this.updatePagerCount);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updatePagerCount);
    },
}
</script>

<style lang="scss">
.contact_us {
    background-color: #F6FAFC;
    padding: 20px 0 80px 0;

    .us_content {
        background-color: #fff;
        padding: 30px;
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        line-height: 1.5;

        .content_left,
        .content_right {
            flex: 0 0 43%
        }

        .content_left {
            .left_tips {
                font-size: 16px;
                color: black;
            }

            .left_hint {
                color: #5e5e60;

                .storng_text {
                    color: black;
                    text-decoration: underline;

                    &:hover {
                        cursor: pointer;
                    }
                }
            }
        }

        .content_right {

            .right_title,
            .right_content,
            .right_support1,
            .right_support2,
            .right_author {
                margin-bottom: 30px;
                font-size: 16px;
            }

            .right_title {
                color: black;
                font-weight: bold;
            }

            .right_content {
                color: #5e5e60;
                line-height: 1.8;
            }

            .right_support1,
            .right_support2 {
                color: #5e5e60;

                a {
                    color: black;
                    text-decoration: underline;
                }
            }

            .right_support {
                margin-bottom: 10px;

                .address {
                    margin-bottom: 10px;
                }
            }

            .right_author {
                border: 1px dashed #1da6b8;
                padding: 40px 30px;
                display: flex;
                align-items: center;
                border-radius: 10px;

                .info_name {
                    font-weight: bold;
                    color: #1da6b8;
                    margin-bottom: 4px;
                    font-size: 16px;
                }

                .info_rank {
                    color: #5e5e60;
                }
            }
        }
    }

    .dialog_footer {
        text-align: left;
        margin-left: auto;
        margin-top: 20px;
    }
}

@media (max-width: 768px) {
    .contact_us {
        .us_content {
            flex-direction: column-reverse;

            .content_right {
                .right_author {
                    padding: 30px 20px;

                    .author_info {
                        margin-left: 20px;
                        flex: 1;
                    }
                }
            }
        }
    }
}
</style>